<!--
 * @Description: 
 * @Date: 2021-09-06 11:51:21
-->
<template>
  <div>
    <div style="position:relative;z-index:0;">
      <el-checkbox
        style="margin-right: 0;"
        v-for="item in checkBoxs"
        :key="item.key"
        v-model="info[item.key]"
        :label="item.label"
        border
        size="medium"
        :true-label="1"
        :false-label="0"
        :disabled="disabled"
      ></el-checkbox>
    </div>
    <div style="color:red;font-size:14px;line-height:1.3;">
      *启用此功能，请如实填写子账号人员（即审核人员）姓名
    </div>
  </div>
</template>

<script>
export default {
  name: 'reviewer-setting',
  props: {
    disabled: Boolean,
    info: Object
  },
  data() {
    return {
      checkBoxs: [
        {
          label: '后台',
          key: 'isAuditCso'
        },
        {
          label: '甲方',
          key: 'isAuditGongye'
        },
        {
          label: '自然人',
          key: 'isAuditAllince'
        }
      ]
    };
  },
  created() {
    // 注入默认值
    this.checkBoxs.forEach(({ key }) => {
      this.info[key] = this.info[key] || 0;
    });
  },
  beforeDestroy() {
    // 组件销毁时，重置字段
    this.checkBoxs.forEach(({ key }) => {
      this.info[key] = 0;
    });
  }
};
</script>
<style lang="scss" scoped></style>
